import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Edit, Delete } from '@mui/icons-material';
import { ActionsButtons } from '../../components/CustomButtons/ActionsButtons';
import { ModalV2 } from '../../components/Modal/ModalV2';
import ElectronicEquipmentForm from './ElectronicEquipmentForm';
import { useRuleValidator } from '../../hooks/useRuleValidator';
import { useToggle } from '../../hooks/useToggle';
import { PERMISSIONS } from '../../router/permissions';
import { deleteElectronicEquipment } from '../../redux/actions/electronicEquipment/electronicEquipmentActions';

const ActionsCell = ({ original }) => {
  const dispatch = useDispatch();
  const [isEditOpen, toggleEdit] = useToggle();
  const [isDeleteOpen, toggleDelete] = useToggle();
  const loading = useSelector(({ search }) => search?.isLoadingComp?.delete);
  // Delete validation
  const canDelete = useRuleValidator(PERMISSIONS.ELECTRONIC_EQUIPMENT_DELETE);

  const handleDelete = () => {
    dispatch(deleteElectronicEquipment(original.id, toggleDelete));
  };

  const buttons = [
    {
      Icon: Edit,
      color: 0,
      onClick: toggleEdit,
      tooltip: "Modificar equipo"
    },
    {
      Icon: Delete,
      color: 3,
      onClick: toggleDelete,
      tooltip: "Eliminar equipo",
      validation: canDelete,
    }
  ];

  return (
    <>
      <ActionsButtons buttons={buttons} />

      {isEditOpen && (
        <ElectronicEquipmentForm
          isOpen={isEditOpen}
          data={original}
          onClose={toggleEdit}
        />
      )}
      
      <ModalV2
        title="¿Seguro que desea eliminar este equipo electrónico?"
        confirmText="Eliminar"
        open={isDeleteOpen}
        onClose={toggleDelete}
        onSubmit={handleDelete}
        justConfirm
        isLoading={loading}
        confirmColor="warning"
      />
    </>
  );
};

export const columns = [
  {
    Header: "Equipo",
    accessor: "equipmentTypeName",
    filterable: true,
    filterMethod: (filter, row) =>
      row.equipmentTypeName?.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Número",
    accessor: "number",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row.number)?.includes(filter.value),
  },
  {
    Header: "Clave",
    accessor: "code",
    filterable: true,
    filterMethod: (filter, row) =>
      row.code?.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Estación",
    accessor: "stationName",
    filterable: true,
    filterMethod: (filter, row) =>
      row.stationName?.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "No. serie",
    accessor: "serialNumber",
    filterable: true,
    filterMethod: (filter, row) =>
      row.serialNumber?.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Estado",
    accessor: "statusLabel",
    filterable: true,
    filterMethod: (filter, row) =>
      row.statusLabel?.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Acciones",
    filterable: false,
    Cell: ActionsCell,
  },
];